import React from 'react';
import { FadeIn } from './FadeIn';
import { CountdownTimer } from './CountdownTimer';
import { CtaButton } from './CtaButton';
import { Shield, Lock, CreditCard } from '@mui/icons-material';
export function FinalCtaSection() {
  return <section className="py-16 px-4 bg-miel-darkest relative border-t-4 border-miel-crimson" data-id="element-64">
      {/* Background elements */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(123,30,58,0.2)_0%,rgba(13,5,5,1)_70%)] pointer-events-none" data-id="element-65" />

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-66">
        {/* Urgency Header */}
        <FadeIn data-id="element-67">
          <div className="text-center mb-10" data-id="element-68">
            <h2 className="text-miel-gold tracking-widest uppercase text-sm font-bold mb-6 flex items-center justify-center gap-2" data-id="element-69">
              <span data-id="element-70">⏰</span> EL PRECIO CIERRA EN:
            </h2>
            <CountdownTimer data-id="element-71" />
          </div>
        </FadeIn>

        {/* Pricing Cards (Simplified for final CTA) */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto mb-10" data-id="element-72">
          {/* Card 1: Standard */}
          <FadeIn delay={0.2} direction="up" data-id="element-73">
            <div className="bg-miel-dark border border-miel-crimson/30 rounded-2xl p-6 md:p-8 flex flex-col h-full text-center" data-id="element-74">
              <div className="text-3xl mb-2" data-id="element-75">📕</div>
              <h4 className="font-playfair text-xl text-miel-cream font-bold mb-1" data-id="element-76">
                MIEL ROJA™
              </h4>
              <p className="text-miel-goldLight italic mb-4 text-sm" data-id="element-77">
                El Protocolo del Retorno
              </p>
              <p className="text-xs text-miel-cream/60 mb-6" data-id="element-78">
                2 Tomos + 5 Bonos · Sistema completo de retorno
              </p>

              <div className="mt-auto" data-id="element-79">
                <div className="flex items-center justify-center gap-3 mb-6" data-id="element-80">
                  <span className="text-lg text-miel-cream/40 line-through" data-id="element-81">
                    $62.000
                  </span>
                  <span className="text-3xl font-playfair font-bold text-miel-cream" data-id="element-82">
                    $19.999{' '}
                    <span className="text-sm text-miel-cream/60" data-id="element-83">ARS</span>
                  </span>
                </div>
                <CtaButton fullWidth className="text-sm py-3" data-id="element-84">
                  🔴 → QUIERO MI MIEL ROJA AHORA
                </CtaButton>
              </div>
            </div>
          </FadeIn>

          {/* Card 2: Premium (Sello de Oro) */}
          <FadeIn delay={0.3} direction="up" data-id="element-85">
            <div className="bg-gradient-to-b from-miel-dark to-miel-darker border-2 border-miel-gold rounded-2xl p-6 md:p-8 flex flex-col h-full text-center shadow-[0_0_30px_rgba(212,175,55,0.1)]" data-id="element-86">
              <div className="text-3xl mb-2" data-id="element-87">🏆</div>
              <h4 className="font-playfair text-xl text-miel-gold font-bold mb-1" data-id="element-88">
                MIEL ROJA™ + SELLO DE ORO ⭐
              </h4>
              <p className="text-miel-cream italic mb-4 text-sm" data-id="element-89">
                El Protocolo del Retorno + Blindaje Completo de la Unión
              </p>
              <p className="text-xs text-miel-cream/60 mb-6" data-id="element-90">
                2 Tomos + 5 Bonos + Sello de Oro
              </p>

              <div className="mt-auto" data-id="element-91">
                <div className="flex items-center justify-center gap-3 mb-6" data-id="element-92">
                  <span className="text-lg text-miel-cream/40 line-through" data-id="element-93">
                    $109.000
                  </span>
                  <span className="text-3xl font-playfair font-bold text-miel-gold" data-id="element-94">
                    $29.999{' '}
                    <span className="text-sm text-miel-gold/60" data-id="element-95">ARS</span>
                  </span>
                </div>
                <CtaButton fullWidth className="text-sm py-3 bg-gradient-to-r from-miel-gold to-miel-goldLight text-miel-darkest hover:from-miel-goldLight hover:to-miel-gold border-none" data-id="element-96">
                  🔴 → QUIERO MIEL ROJA + SELLO DE ORO
                </CtaButton>
              </div>
            </div>
          </FadeIn>
        </div>

        {/* Trust Badges */}
        <FadeIn delay={0.4} data-id="element-97">
          <div className="flex flex-wrap justify-center gap-6 md:gap-12 text-sm text-miel-cream/60 mb-12 pb-8 border-b border-miel-crimson/20" data-id="element-98">
            <div className="flex items-center gap-2" data-id="element-99">
              <Lock fontSize="small" className="text-miel-gold/70" data-id="element-100" /> Pago 100%
              seguro
            </div>
            <div className="flex items-center gap-2" data-id="element-101">
              <span className="text-miel-gold/70" data-id="element-102">⚡</span> Acceso en 5 minutos
            </div>
            <div className="flex items-center gap-2" data-id="element-103">
              <Shield fontSize="small" className="text-miel-gold/70" data-id="element-104" /> Garantía
              7 días
            </div>
            <div className="flex items-center gap-2" data-id="element-105">
              <CreditCard fontSize="small" className="text-miel-gold/70" data-id="element-106" />{' '}
              Mercado Pago · Tarjeta · Transferencia
            </div>
          </div>
        </FadeIn>

        {/* Footer */}
        <FadeIn delay={0.5} data-id="element-107">
          <footer className="text-center" data-id="element-108">
            <div className="text-4xl mb-4" data-id="element-109">🕯️</div>
            <h2 className="text-miel-crimson font-bold tracking-widest text-lg mb-2" data-id="element-110">
              MIEL ROJA™
            </h2>
            <p className="font-playfair text-xl text-miel-cream mb-6" data-id="element-111">
              El Protocolo del Retorno
            </p>
            <p className="text-sm text-miel-cream/50 max-w-md mx-auto mb-8" data-id="element-112">
              El sistema de rituales de endulzamiento y retorno amoroso N°1 para
              la mujer moderna.
            </p>
            <p className="text-miel-goldLight italic font-playfair text-lg" data-id="element-113">
              Porque el amor que es tuyo no debería perderse por el muro del
              orgullo.
            </p>
            <div className="mt-12 text-xs text-miel-cream/30" data-id="element-114">
              © {new Date().getFullYear()} Miel Roja. Todos los derechos
              reservados.
            </div>
          </footer>
        </FadeIn>
      </div>
    </section>;
}